import { Box, Card, CardContent, Typography } from "@mui/material";
import { getBackgroundColor, getRelevanceColor } from "../../utils/utils";

interface ChannelCardProps {
  id: string;
  title: string;
  relevance: number;
  keywordClusters: number;
  handleCardClick: (id: string) => void;
}

const ChannelCard = ({
  id,
  title,
  relevance,
  keywordClusters,
  handleCardClick,
}: ChannelCardProps) => {

  const relevanceColor = getRelevanceColor(relevance);
  const backgroundColor = getBackgroundColor(relevance);
  
  return (
    <Card
      onClick={() => handleCardClick(id)}
      sx={{
        borderRadius: 3,
        bgcolor: "#fff",
        boxShadow: "none",
        cursor: "pointer",
        width: "100%",
        minWidth: "0",
        display: "flex",
        flexDirection: "column",
        minHeight: '100px'
      }}
    >
      <CardContent sx={{ p: "10px !important" }}>
        <Typography
          variant="subtitle1"
          fontWeight={500}
          gutterBottom
          sx={{ 
            color: "#171D1A",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%"
          }}
        >
          {title}
        </Typography>
        <Box display="flex" alignItems="center" gap={0.5}>
          <Typography variant="caption" color="text.secondary">
            Business Relevance
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            padding={0.5}
            gap={0.3}
            sx={{ backgroundColor: backgroundColor, borderRadius: "10px" }}
          >
            {[...Array(5)].map((_, i) => (
              <Box
                key={i}
                sx={{
                  width: 5,
                  height: 5,
                  borderRadius: "50%",
                  bgcolor: i < relevance ? relevanceColor : "#E0E0E0",
                  display: "inline-block",
                }}
              />
            ))}
          </Box>
        </Box>
        <Box display={"flex"} gap={0.5} marginTop={0.5}>
          <Typography variant="caption" color="text.secondary">
            Keyword Clusters:{" "}
          </Typography>
          <Typography variant="caption" fontWeight={700} color="text.secondary">
            {keywordClusters}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChannelCard;
